export enum DatePickerType {
  date = 'date',
  time = 'time',
  dateTime = 'dateTime'
}
